/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Section_FeaturesInputs */

const cs_property_section_features = /** @type {(inputs: Property_Section_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybavení`)
};

const en_property_section_features = /** @type {(inputs: Property_Section_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Property_Section_FeaturesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_section_features = /** @type {((inputs?: Property_Section_FeaturesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Section_FeaturesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_section_features(inputs)
	return cs_property_section_features(inputs)
});